"use strict";
/*
 * HSPinInput
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSPinInput = /** @class */ (function (_super) {
    __extends(HSPinInput, _super);
    function HSPinInput(el, options) {
        var _this = _super.call(this, el, options) || this;
        var data = el.getAttribute('data-hs-pin-input');
        var dataOptions = data ? JSON.parse(data) : {};
        var concatOptions = __assign(__assign({}, dataOptions), options);
        _this.items = _this.el.querySelectorAll('[data-hs-pin-input-item]');
        _this.currentItem = null;
        _this.currentValue = new Array(_this.items.length).fill('');
        _this.placeholders = [];
        _this.availableCharsRE = new RegExp((concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.availableCharsRE) || '^[a-zA-Z0-9]+$'); // '^[0-9]+$'
        _this.init();
        return _this;
    }
    HSPinInput.prototype.init = function () {
        this.createCollection(window.$hsPinInputCollection, this);
        if (this.items.length)
            this.build();
    };
    HSPinInput.prototype.build = function () {
        this.buildInputItems();
    };
    HSPinInput.prototype.buildInputItems = function () {
        var _this = this;
        this.items.forEach(function (el, index) {
            _this.placeholders.push(el.getAttribute('placeholder') || '');
            if (el.hasAttribute('autofocus'))
                _this.onFocusIn(index);
            el.addEventListener('input', function (evt) { return _this.onInput(evt, index); });
            el.addEventListener('paste', function (evt) { return _this.onPaste(evt); });
            el.addEventListener('keydown', function (evt) { return _this.onKeydown(evt, index); });
            el.addEventListener('focusin', function () { return _this.onFocusIn(index); });
            el.addEventListener('focusout', function () { return _this.onFocusOut(index); });
        });
    };
    HSPinInput.prototype.checkIfNumber = function (value) {
        return value.match(this.availableCharsRE);
    };
    HSPinInput.prototype.autoFillAll = function (text) {
        var _this = this;
        Array.from(text).forEach(function (n, i) {
            if (!(_this === null || _this === void 0 ? void 0 : _this.items[i]))
                return false;
            _this.items[i].value = n;
            _this.items[i].dispatchEvent(new Event('input', { bubbles: true }));
        });
    };
    HSPinInput.prototype.setCurrentValue = function () {
        this.currentValue = Array.from(this.items).map(function (el) { return el.value; });
    };
    HSPinInput.prototype.toggleCompleted = function () {
        if (!this.currentValue.includes(''))
            this.el.classList.add('active');
        else
            this.el.classList.remove('active');
    };
    HSPinInput.prototype.onInput = function (evt, index) {
        var originalValue = evt.target.value;
        this.currentItem = evt.target;
        this.currentItem.value = '';
        this.currentItem.value = originalValue[originalValue.length - 1];
        if (!this.checkIfNumber(this.currentItem.value)) {
            this.currentItem.value = this.currentValue[index] || '';
            return false;
        }
        this.setCurrentValue();
        if (this.currentItem.value) {
            if (index < this.items.length - 1)
                this.items[index + 1].focus();
            if (!this.currentValue.includes('')) {
                var payload = { currentValue: this.currentValue };
                this.fireEvent('completed', payload);
                (0, utils_1.dispatch)('completed.hs.pinInput', this.el, payload);
            }
            this.toggleCompleted();
        }
        else {
            if (index > 0)
                this.items[index - 1].focus();
        }
    };
    HSPinInput.prototype.onKeydown = function (evt, index) {
        if (evt.key === 'Backspace' && index > 0) {
            if (this.items[index].value === '') {
                this.items[index - 1].value = '';
                this.items[index - 1].focus();
            }
            else {
                this.items[index].value = '';
            }
        }
        this.setCurrentValue();
        this.toggleCompleted();
    };
    HSPinInput.prototype.onFocusIn = function (index) {
        this.items[index].setAttribute('placeholder', '');
    };
    HSPinInput.prototype.onFocusOut = function (index) {
        this.items[index].setAttribute('placeholder', this.placeholders[index]);
    };
    HSPinInput.prototype.onPaste = function (evt) {
        var _this = this;
        evt.preventDefault();
        this.items.forEach(function (el) {
            if (document.activeElement === el)
                _this.autoFillAll(evt.clipboardData.getData('text'));
        });
    };
    // Static method
    HSPinInput.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsPinInputCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element
            : null;
    };
    HSPinInput.autoInit = function () {
        if (!window.$hsPinInputCollection)
            window.$hsPinInputCollection = [];
        document
            .querySelectorAll('[data-hs-pin-input]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsPinInputCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSPinInput(el);
        });
    };
    return HSPinInput;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSPinInput.autoInit();
    // Uncomment for debug
    // console.log('PIN input collection:', window.$hsPinInputCollection);
});
if (typeof window !== 'undefined') {
    window.HSPinInput = HSPinInput;
}
exports.default = HSPinInput;
